import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./routes/MainRoutes";
import UserState from "./context/UserState";

function App() {

  return (
    <UserState>

      <BrowserRouter>

        <MainRoutes></MainRoutes>
    
      </BrowserRouter>


    </UserState>


  );
}

export default App;
